import { ComponentType, FC } from "react";
import type { LucideIcon } from "lucide-react";
import { NodePanelProps } from "./panel/panel-container";
import { NodeColorKey } from "./node-color-to-tailwind-classes";
import { TriggerNodeDataDto, WorkflowV2NodeDto } from "@babackapp/private-api-client/types";


export enum NodeCategory {
  TRIGGER = "trigger",
  ACTION = "action",
  CONDITION = "condition",
}

export type NodeConfig = {
  type: string;
  name: string;
  description: string;
  Icon: LucideIcon;
  category: NodeCategory;
  color: NodeColorKey;
  newNodeDefaultData: WorkflowV2NodeDto['data'] | TriggerNodeDataDto;
  premium?: boolean;
};

export type NodeEditorComponent<P> = ComponentType<{ data: P, id: string }>;
export type NodePanelComponent<P> = FC<NodePanelProps<P>>;

export type NodeRegisterInput<P> = NodeConfig & {
  editor: {
    component: NodeEditorComponent<P>;
  };
  configPanel?: {
    component: NodePanelComponent<P>;
  };
};

export type RegisteredNode<P = unknown> = {
  config: NodeConfig;
  EditorComponent: NodeEditorComponent<P>;
  ConfigPanel?: NodePanelComponent<P>;
};

export function registerNode<P>(
  input: NodeRegisterInput<P>,
): RegisteredNode<P> {
  const { editor, configPanel, ...config } = input;

  return {
    config,
    EditorComponent: editor.component,
    ConfigPanel: configPanel?.component,
  };
}
